import React from 'react';

const KidsTrainingsPage = () => {
  return <div>KidsTrainingsPage</div>;
};

export default KidsTrainingsPage;
